<script>
  export let title = "";
  export let description = "";
</script>

<h1
  class="uppercase mt-6 pb-2 text-4xl  text-brand flex border-b border-gray-200"
>
  {title}
</h1>
<div class="text-gray-500 mt-4 mb-6 flex items-center">
  <!-- <i class="text-brand fas fa-square text-2xl mr-2" /> -->
  <span class="text-brand mr-1 flex items-center justify-center">
    🔳
  </span>
  <span class="text-brand mr-1 flex items-center justify-center">
    —
  </span>
  {description}
  <span class="text-brand font-extrabold flex items-center justify-center">
    .
  </span>
</div>
